module.exports = __webpack_public_path__ + "static/media/cc.5ab42c18.png";